var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%","width":"100%","position":"fixed","left":"0","top":"0"},attrs:{"id":"map"}})
}
var staticRenderFns = []

export { render, staticRenderFns }